var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-spectrum",style:(_vm.spectrumStyles)},[_c('div',{staticClass:"spectrum-container"},_vm._l((32),function(i){return _c('div',{key:i,staticClass:"spectrum-bar",style:(_vm.getBarStyle(i))})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }